module.exports = __webpack_public_path__ + "static/img/sbaq.96b0f6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fiveG/sbaq.png
// module id = pAPb
// module chunks = 1